import { render, staticRenderFns } from "./avatarPopover.vue?vue&type=template&id=3e2f265e&scoped=true"
import script from "./avatarPopover.vue?vue&type=script&lang=js"
export * from "./avatarPopover.vue?vue&type=script&lang=js"
import style0 from "./avatarPopover.vue?vue&type=style&index=0&id=3e2f265e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f265e",
  null
  
)

export default component.exports